/**
 * Agent 状态徽标元数据（SDD §IV.3 状态机对齐，只增不改）。
 *
 * 仅收录 5 个新状态（后端 AgentStatus 新增成员的小写值）：
 *   draft 草稿 / building 构建中 / running 运行中 / paused 已暂停 / retired 已退役。
 * 旧状态（active / training / archived）**不在**本表内 —— 各页面维持既有渲染，
 * 保证旧显示（文案与配色）一字不变；新状态统一走这里取中文标签与徽标样式。
 */
export const AGENT_STATUS_META: Record<string, { label: string; badgeClass: string }> = {
  draft: { label: '草稿', badgeClass: 'info' },
  building: { label: '构建中', badgeClass: 'warning' },
  running: { label: '运行中', badgeClass: 'success' },
  paused: { label: '已暂停', badgeClass: 'warning' },
  retired: { label: '已退役', badgeClass: 'error' },
};

/** 取新状态的徽标元数据；旧状态返回 undefined（由页面既有逻辑渲染）。 */
export function agentStatusMeta(status: string): { label: string; badgeClass: string } | undefined {
  return AGENT_STATUS_META[status];
}
